import { call, put, select } from 'redux-saga/effects';
import { actionActions } from 'store/data/action';
import { improvementAreaSelectors } from 'store/data/improvementArea';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';
import { timeUtility } from 'utility';

import * as improvementsActions from './actions';
import * as constants from './constants';
import * as improvementsSelectors from './selectors';

// Inserts a temporary placeholder action so the user can fill in the form
// before it is persisted. Replaces any existing mock to avoid duplicates.
// The mock is stamped with the lowest-sortOrder improvement area when one
// exists; the API requires a non-null improvementAreaId on create, so the
// detail editor surfaces a validation error when this stays null.
export function* startCreateMockActionSaga(
  action: ActionType<typeof improvementsActions.startCreateMockAction>,
) {
  function* saga() {
    const startAt = timeUtility.getToday();
    const endAt = timeUtility.step({
      timeDate: startAt,
      step: 'next',
      stepSize: 'week',
    });

    const defaultImprovementAreaId: ReturnType<
      typeof improvementAreaSelectors.defaultImprovementAreaId
    > = yield select(improvementAreaSelectors.defaultImprovementAreaId);

    const mockAction: Data.Action = {
      id: constants.MOCKED_ACTION_ID,
      improvementAreaId: defaultImprovementAreaId,
      name: '',
      problemStatement: '',
      solutionProposal: '',
      status: 'New',
      definitionOfDone: '',
      startAt,
      endAt,
      priority: 'None',
      responsibleEmployee: '',
      suggestionIds: [],
    };

    const hasMockedAction: ReturnType<
      typeof improvementsSelectors.hasMockedAction
    > = yield select(improvementsSelectors.hasMockedAction);

    // Remove stale mock before adding the fresh one
    if (hasMockedAction) {
      yield put(actionActions.remove(mockAction.id));
    }

    yield put(actionActions.add(mockAction));
    yield put(improvementsActions.setSelectedActionId(mockAction.id));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
